import { PageHeading, Pagination } from 'components/atoms';
import { Head, PageLayout } from 'components/molecules';
import EintragungenList from 'components/molecules/Eintragungen/EintragungenList/Eintragungenlist';
import EintragungenFilter from 'components/molecules/Eintragungen/Filter/EintragungenFilter';
import { getTranslations } from 'i18n';
import type { GetServerSideProps, NextPage } from 'next';
import React from 'react';
import { ISO8601Date } from 'types';
import type { Eintragung } from 'types/eintragungen';
import { getCanonicalUrl } from 'utils';
import { useTranslation } from 'utils/hooks';
import { getEintragungen } from 'utils/listStaticProps';


interface InsolvenzeintragungenPageProps
{
  limit: number;
  page: number;
  total: number;
  aktuell: ISO8601Date;
  filters: Record<string, string>;
  insolvenzeintragungen: Eintragung[];
}

const InsolvenzeintragungenPage: NextPage<InsolvenzeintragungenPageProps> = (props) =>
{
  const { filters, insolvenzeintragungen, page, limit, total, aktuell } = props;
  const { t } = useTranslation();

  return (
    <PageLayout>

      <Head
        title={t('eintragungen:insolvenzen.seoTitle')}
        description={t('eintragungen:insolvenzen.seoDescription')}
      >
        <link rel="canonical" href={`${getCanonicalUrl()}/l/insolvenzen`}/>
      </Head>

      <EintragungenFilter
        defaultValues={filters}
        aktuell={aktuell}
        eintragungsart={'insolvenzen'}
        dateOptions={[5, 14, 21, 30, 60]}
      />

      <PageHeading title={t('eintragungen:insolvenzen.heading', { count: total })}/>

      <EintragungenList
        eintragungen={insolvenzeintragungen}
      />

      {insolvenzeintragungen.length > 0 && (
        <Pagination
          activePage={page}
          limit={limit}
          totalResults={total}
          shallow={false}
          scrollTop
        />
      )}

    </PageLayout>
  );
};

export default InsolvenzeintragungenPage;

export const getServerSideProps: GetServerSideProps = async (ctx) => 
{
  const { locale } = ctx;
  const translations = await getTranslations(locale, 'common', 'eintragungen', 'bundesländer');
  const props = await getEintragungen(ctx, 'insolvenzeintragungen');

  return { props: { ...props, ...translations } };
};